"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
// import "swiper/css/navigation";
import "swiper/css/pagination";
import CusTitle from "@/components/Home2/CusTitle.tsx";
import { useTranslations } from "next-intl";

const certificates = [
	"/image/quality-assurance/certificate/1.jpg",
	"/image/quality-assurance/certificate/2.jpg",
	"/image/quality-assurance/certificate/3.jpg",
	"/image/quality-assurance/certificate/4.jpg",
];

export default function CertificateCarousel() {
	const t=useTranslations()
	return (
		<section className="py-12 bg-gray-100">
			<div className="container mx-auto px-4">
				{/*<h2 className="text-3xl font-bold text-center mb-6">International Certifications</h2>*/}
				<CusTitle homeTitle={t("qualityAssurance.interCer")} className=" text-center  pb-8 max-md:py-5"></CusTitle>
				<p className="text-center text-gray-500 max-w-3xl mx-auto">
					{t("qualityAssurance.interCerDsc")}
				</p>

				<Swiper
					modules={[Pagination,  Autoplay]}
					spaceBetween={20}
					slidesPerView={1}
					breakpoints={{
						640: { slidesPerView: 2 },
						1024: { slidesPerView: 4 },
					}}
					// navigation
					pagination={{ clickable: true }}
					autoplay={{ delay: 3000, disableOnInteraction: false }}
					className="mt-8"
				>
					{certificates.map((src, index) => (
						<SwiperSlide key={index} className="flex justify-center">
							<div className="bg-white shadow-md p-4 rounded-lg h-[450px]">
								<Image src={src} alt={`Certificate ${index + 1}`} fill={true} className="rounded-lg" />
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</section>
	);
}
